import { Component, Inject, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ElementdetailsService } from "src/app/Service/elementdetails/elementdetails.service";
import { IElementDetailsViewModel } from "src/app/ViewModel/ElementDetailsModel";
import { StandardOutputModel } from "src/app/ViewModel/StandardOutputModel";
import { CommonService } from 'src/app/Service/Common.service';
import { IElementsViewModel } from 'src/app/ViewModel/ElementsModel';

@Component({
    selector: 'app-master-elementdetails-dialog',
    templateUrl: './edit-elementdetails-dialog.component.html',
    styleUrls: ['./edit-elementdetails-dialog.component.css']
})
export class EditElementDetailsComponent implements OnInit {
    public actionButtonText: string = "Save";
    public isEdit: boolean = false;
    memberId: number | undefined;

    

    /**Element Details array */
    public elementDetailsList?: any | IElementDetailsViewModel;
    public elementList: IElementsViewModel[] = [];
    /**Element Id */
    private elementId: number | undefined;
    public Fromelement: string | undefined;
    public ToelementId: number | undefined | null;
    public selectedElementType: string = "newelement";
    public elementDetailsForm: FormGroup = new FormGroup({
        elementDetailName: new FormControl('', [Validators.required, Validators.maxLength(600)]),
        elementDetailShortName: new FormControl('', [Validators.required, Validators.maxLength(100)]),
        elementDetailDEDCode: new FormControl(''),
        elementDetailStatus: new FormControl(true),
        FromElement: new FormControl(''),
        ToElement: new FormControl('')
    });

    constructor(private _elementDetailsService: ElementdetailsService, private _commonService: CommonService, public _dialogRef: MatDialogRef<EditElementDetailsComponent>,
        @Inject(MAT_DIALOG_DATA) public _data: any) {
        this.elementDetailsList = _data.elementdetails;
        this.elementId = _data.elementId;
        this.elementList = _data.elementList;
        if (this.elementId) {
            this.Fromelement = this.elementList.filter(x => x.dE_Id == this.elementId)[0].dE_Description;
            this.elementDetailsForm.get('FromElement')?.setValue(this.Fromelement);
            this.elementList = this.elementList.filter(x => x.dE_Id != this.elementId);
        }

    }
    /**
     * ngOnInit - Angular Lifecycle hook
     */
    ngOnInit() {
        this.memberId = this._commonService.getLoggedInUserId();
        if (this.elementDetailsList != null) {
            this.actionButtonText = "Update";
            this.isEdit = true;
            this.setFormValues();
        }
    }
    /**
     * Set form values
     */
    setFormValues() {
        this.elementDetailsForm.get('elementDetailName')?.setValue(this.elementDetailsList.deD_Description);
        this.elementDetailsForm.get('elementDetailShortName')?.setValue(this.elementDetailsList.deD_Short_Description);
        this.elementDetailsForm.get('elementDetailDEDCode')?.setValue(this.elementDetailsList.deD_CODE);
        this.elementDetailsForm.get('elementDetailStatus')?.setValue(this.elementDetailsList.is_Active);
    }

    /**
     * Save elementdetails 
     */
    saveElementDetails() {
        if (this.selectedElementType == 'newelement') {
            let elementdetails: IElementDetailsViewModel = {
                deD_Description: this.getFormValue('elementDetailName'), deD_Short_Description: this.getFormValue('elementDetailShortName'), deD_CODE: this.getFormValue('elementDetailDEDCode'),
                is_Active: this.getFormValue('elementDetailStatus'), deD_Id: this.elementDetailsList != null ? this.elementDetailsList.deD_Id : null, dE_Id: this.elementId, userId: this.memberId
            };
            this._elementDetailsService.insertUpdateElementDetails(elementdetails).subscribe((res: StandardOutputModel) => {
                if (res.successCode == 200) {
                    if (this.elementDetailsList == null)
                        elementdetails.deD_Id = +res.result;
                    this._dialogRef.close({ response: res, elementdetails: elementdetails });
                }
                else if (res.successCode == 500) {
                    this._dialogRef.close({ response: res });
                }
                else if (res.successCode == 205) {
                    this._dialogRef.close({ response: res });
                }
            }, err => {

            });

        }
        else {
            let input: any = {
                FromElementID: this.elementId,
                ToElementID: this.ToelementId
            };
            this._elementDetailsService.CopyElementDetails(input).subscribe((res: StandardOutputModel) => {
                if (res.successCode == 200) {

                    this._dialogRef.close({ response: res });
                }
                else {
                    this._dialogRef.close({ response: res });
                }
            }, err => {

            });
        }
    }


    ToElementChange(selectedElement: any) {
        if (selectedElement && selectedElement.dE_Id) {
            this.ToelementId = selectedElement.dE_Id;
        }
        else
            this.ToelementId = null;

    }
    ElementTypeChange(selectedElement: any) {
        if (selectedElement.value) {
            this.selectedElementType = selectedElement.value;
        }

    }


    /**
     * Get elementDetailsForm Controls value
     * @param controlName ControlName
     */
    getFormValue(controlName: string): any {
        return this.elementDetailsForm.get(controlName)?.value;
    }

    /**
     * Close modal dialog
     */
    closeDialog() {
        this._dialogRef.close();
    }
}